// =============================================================================
// useConversationLeadCities.ts — cidades disponíveis no filtro do inbox (F16-S57).
//
// Alimenta o dropdown de cidade do live chat. A API devolve apenas as cidades
// que de fato têm lead com conversa — listar as 52 de Rondônia daria um menu
// onde a maioria das opções não filtra nada.
// =============================================================================

import { useQuery } from '@tanstack/react-query';

import { api } from '../lib/api';

export interface LeadCityOption {
  readonly id: string;
  readonly name: string;
}

interface LeadCitiesResponse {
  readonly cities: readonly LeadCityOption[];
}

export const conversationLeadCitiesKey = ['conversations', 'leadCities'] as const;

export function useConversationLeadCities(): {
  cities: readonly LeadCityOption[];
  isLoading: boolean;
} {
  const { data, isLoading } = useQuery({
    queryKey: conversationLeadCitiesKey,
    queryFn: async (): Promise<LeadCitiesResponse> =>
      api.get<LeadCitiesResponse>('/api/conversations/lead-cities'),
    // O conjunto de cidades muda devagar (só quando um lead novo ganha cidade).
    staleTime: 5 * 60 * 1000,
  });

  return { cities: data?.cities ?? [], isLoading };
}
